import { render, staticRenderFns } from "./portfolio_risk.vue?vue&type=template&id=b3e62330&scoped=true&"
import script from "./portfolio_risk.vue?vue&type=script&lang=js&"
export * from "./portfolio_risk.vue?vue&type=script&lang=js&"
import style0 from "./portfolio_risk.vue?vue&type=style&index=0&id=b3e62330&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e62330",
  null
  
)

export default component.exports